import { Check, X, Quote } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const WITHOUT = [
  "Le commercial ne peut rien proposer.",
  "Le besoin part chez quelqu'un d'autre.",
  "L'opportunité est perdue.",
];
const WITH = [
  "Le commercial ouvre Leadzi CHR.",
  "Il dépose l'opportunité en quelques minutes.",
  "Leadzi analyse le besoin.",
  "Leadzi lui fait une proposition de rémunération.",
];

export const Example = () => {
  return (
    <section id="how" className="relative scroll-mt-20 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Overline>Un exemple concret</Overline>
          <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Un exemple&nbsp;? C'est très simple.
          </h2>
        </Reveal>

        {/* situation */}
        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col gap-5 rounded-3xl border border-black/5 bg-[#FAFAFA] p-7 sm:flex-row sm:items-center sm:gap-7 lg:p-9">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand text-white">
              <Quote className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm font-bold uppercase tracking-wider text-ink/40">La situation</p>
              <p className="mt-1 text-lg font-semibold text-ink">
                Un commercial en denrées alimentaires est chez son client restaurateur. Celui-ci lui dit&nbsp;:
                <span className="text-brand"> « Je cherche une nouvelle caisse pour mon restaurant. »</span>{" "}
                Mais le commercial ne vend pas de caisse.
              </p>
            </div>
          </div>
        </Reveal>

        {/* comparison */}
        <div className="mt-6 grid gap-5 md:grid-cols-2 lg:gap-6">
          <Reveal delay={0.1}>
            <div data-testid="comparison-without-leadzi" className="h-full rounded-3xl border border-red-100 bg-red-50/40 p-7 lg:p-8">
              <h3 className="text-sm font-bold uppercase tracking-wider text-red-500">Sans Leadzi</h3>
              <ul className="mt-6 space-y-4">
                {WITHOUT.map((t) => (
                  <li key={t} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500">
                      <X className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-ink/70">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div data-testid="comparison-with-leadzi" className="relative h-full overflow-hidden rounded-3xl border border-brand/20 bg-brand-light p-7 lg:p-8">
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-brand/10 blur-2xl" />
              <h3 className="text-sm font-bold uppercase tracking-wider text-brand-700">Avec Leadzi</h3>
              <ul className="mt-6 space-y-4">
                {WITH.map((t) => (
                  <li key={t} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand text-white">
                      <Check className="h-3.5 w-3.5" strokeWidth={3} />
                    </span>
                    <span className="font-medium text-ink">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
